import axios from "axios";

const baseURL = "https://ai.shipday.com";

const aiClient = axios.create({
    baseURL: baseURL
});

export default aiClient; 
